let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kr1hG")).then(() => parcelRequire('681mP'));